import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaHeart, FaUser, FaShoppingCart } from "react-icons/fa";
import Book_appointment_modal from "../common-components/common-modals/book-appointment-modal/Book_appointment_modal";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo } from "../../features/user/userSlice";
import { getAllProducts } from "../../features/products/productsSlice";
import { getAllCart } from "../../features/cart/cartSlice";
import {
  AllBrand,
  getAllCategories,
  getAllGender,
  getAllShape,
  getAllSubCategory,
} from "../../features/master/masterSlice";

const SHAPES = [
  { key: "aviator", label: "Aviator" },
  { key: "wayfarer", label: "Wayfarer" },
  { key: "round", label: "Round" },
  { key: "square", label: "Square" },
  { key: "rectangle", label: "Rectangle" },
  { key: "cateye", label: "Cat-Eye" },
  { key: "geometric", label: "Geometric" },
  { key: "oversized", label: "Oversized" },
];

const ShapeIcon = ({ shapeKey }) => {
  const common = {
    width: 20,
    height: 14,
    viewBox: "0 0 24 16",
    fill: "none",
  };

  switch (shapeKey) {
    case "round":
      return (
        <svg {...common}>
          <circle
            cx="6"
            cy="8"
            r="6"
            stroke="currentColor"
            strokeWidth="1.4"
          />
          <circle
            cx="18"
            cy="8"
            r="6"
            stroke="currentColor"
            strokeWidth="1.4"
          />
        </svg>
      );

    case "square":
      return (
        <svg {...common}>
          <rect
            x="1"
            y="2"
            width="10"
            height="10"
            rx="1.5"
            stroke="currentColor"
            strokeWidth="1.4"
          />
          <rect
            x="13"
            y="2"
            width="10"
            height="10"
            rx="1.5"
            stroke="currentColor"
            strokeWidth="1.4"
          />
        </svg>
      );

    case "rectangle":
      return (
        <svg {...common}>
          <rect
            x="0.5"
            y="3"
            width="11"
            height="7"
            rx="1.5"
            stroke="currentColor"
            strokeWidth="1.4"
          />
          <rect
            x="12.5"
            y="3"
            width="11"
            height="7"
            rx="1.5"
            stroke="currentColor"
            strokeWidth="1.4"
          />
        </svg>
      );

    case "cateye":
      return (
        <svg {...common}>
          <path
            d="M1 9c0-4 3-6 5-6s4 2 5 6"
            stroke="currentColor"
            strokeWidth="1.4"
            fill="none"
          />
          <path
            d="M13 9c0-4 3-6 5-6s4 2 5 6"
            stroke="currentColor"
            strokeWidth="1.4"
            fill="none"
          />
        </svg>
      );

    case "geometric":
      return (
        <svg {...common}>
          <polygon
            points="6,1 11,5 9,11 3,11 1,5"
            stroke="currentColor"
            strokeWidth="1.4"
            fill="none"
          />
          <polygon
            points="18,1 23,5 21,11 15,11 13,5"
            stroke="currentColor"
            strokeWidth="1.4"
            fill="none"
          />
        </svg>
      );

    case "oversized":
      return (
        <svg {...common}>
          <circle
            cx="6"
            cy="8"
            r="7"
            stroke="currentColor"
            strokeWidth="1.4"
          />
          <circle
            cx="18"
            cy="8"
            r="7"
            stroke="currentColor"
            strokeWidth="1.4"
          />
        </svg>
      );

    case "wayfarer":
      return (
        <svg {...common}>
          <path
            d="M0.5 4h11l-1.5 6h-8z"
            stroke="currentColor"
            strokeWidth="1.4"
            fill="none"
          />
          <path
            d="M12.5 4h11l-1.5 6h-8z"
            stroke="currentColor"
            strokeWidth="1.4"
            fill="none"
          />
        </svg>
      );

    default:
      return (
        <svg {...common}>
          <path
            d="M6 2C3 2 1 5 1 8c0 3 2 5 5 5s5-2 5-5c0-1-0.5-2-1-3"
            stroke="currentColor"
            strokeWidth="1.4"
            fill="none"
          />
          <path
            d="M18 2c-3 0-5 3-5 6 0 3 2 5 5 5s5-2 5-5c0-1-0.5-2-1-3"
            stroke="currentColor"
            strokeWidth="1.4"
            fill="none"
          />
        </svg>
      );
  }
};

function Header({
  filters,
  handleFilterChange,
  handleMegaFilterChange,
  handleSingleCategoryFilter,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [modalShow, setModalShow] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileAccordion, setMobileAccordion] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);

  const closeTimer = useRef(null);

  const is_signin = useSelector(
    (state) => state.auth.is_signin
  );

  const user = useSelector(
    (state) => state.user.userInfo
  );

  const cartItems = useSelector(
    (state) => state.cart.allCarts
  );

  const categories = useSelector(
    (state) => state.master.categories
  );

  const allGender = useSelector(
    (state) => state.master.all_gender
  );

  const allShape = useSelector(
    (state) => state.master.all_shape
  );

  const allBrands = useSelector(
    (state) => state.master.all_brands
  );

  const subcategories = useSelector(
    (state) => state.master.subcategories
  );

  useEffect(() => {
    dispatch(getAllProducts());
    dispatch(getAllCategories());
    dispatch(getAllGender());
    dispatch(getAllShape());
    dispatch(AllBrand());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllCart(is_signin));

    if (is_signin) {
      dispatch(getUserInfo());
    }
  }, [is_signin, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);

    setMobileOpen(false);
    setMobileAccordion(null);
    setActiveMenu(null);
  }, [location.pathname]);

  const openMenu = (key) => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
    }

    setActiveMenu(key);
  };

  const scheduleClose = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
    }

    closeTimer.current = setTimeout(() => {
      setActiveMenu(null);
    }, 180);
  };

 
 
const CATEGORY_IDS = {
  SPECTACLE_FRAMES: 5,
  SUNGLASSES: 2,
  SPECTACLE_LENSES: 1,
  CONTACT_LENSES: 3,
  META: 8,
  KIDS: 9,
  ACCESSORIES: 4,
};

const findCategoryById = (id) =>
  categories?.find((c) => c.id === id);

const sunglassesCat = findCategoryById(CATEGORY_IDS.SUNGLASSES);
const eyeglassesCat = findCategoryById(CATEGORY_IDS.SPECTACLE_FRAMES);
const kidsCat = findCategoryById(CATEGORY_IDS.KIDS);

const kidsGender = allGender?.find(
  (g) => g.name?.toLowerCase() === "kids"
);
const boysGender = allGender?.find(
  (g) => g.name?.toLowerCase() === "boys"
);
const girlsGender = allGender?.find(
  (g) => g.name?.toLowerCase() === "girls"
);

const contactLensCat = findCategoryById(CATEGORY_IDS.CONTACT_LENSES);
const metaCategory = findCategoryById(CATEGORY_IDS.META);

  useEffect(() => {
    if (
      activeMenu === "sunglasses" &&
      sunglassesCat
    ) {
      dispatch(
        getAllSubCategory(sunglassesCat.id)
      );
    }

    if (
      activeMenu === "eyeglasses" &&
      eyeglassesCat
    ) {
      dispatch(
        getAllSubCategory(eyeglassesCat.id)
      );
    }
  }, [
    activeMenu,
    sunglassesCat,
    eyeglassesCat,
    dispatch,
  ]);

  /*
   * ============================================================
   * NORMAL FILTER
   *
   * Used for filters that should behave normally.
   * ============================================================
   */

  const applyFilter = (filterType, value) => {
    handleFilterChange(filterType, value);

    navigate("/all-products");

    setMobileOpen(false);
    setMobileAccordion(null);
    setActiveMenu(null);
  };

  /*
   * ============================================================
   * MEGA MENU FILTER
   
   */

  const applyMegaFilter = (
    primaryType,
    primaryValue,
    secondaryType,
    secondaryValue
  ) => {
    handleMegaFilterChange(
      primaryType,
      primaryValue,
      secondaryType,
      secondaryValue
    );

    navigate("/all-products");

    setMobileOpen(false);
    setMobileAccordion(null);
    setActiveMenu(null);
  };

  /*
   * ============================================================
   * SINGLE CATEGORY FILTER (Meta AI)
   
   
   */

  const applySingleCategory = (category) => {
    handleSingleCategoryFilter(category);

    navigate("/all-products");

    setMobileOpen(false);
    setMobileAccordion(null);
    setActiveMenu(null);
  };

  const sortedBrands = React.useMemo(
    () =>
      [...(allBrands || [])].sort((a, b) =>
        (a.name || "").localeCompare(b.name || "")
      ),
    [allBrands]
  );

  const topBrands = sortedBrands.slice(0, 8);

  const exclusiveBrands = sortedBrands.slice(8, 16);

  const renderCategoryMegaMenu = (category) => (
    <div className="mega_panel">

      <div className="mega_col">
        <h6>By Gender</h6>

        <ul>
          {allGender && allGender.length > 0 ? (
            allGender.map((g) => (
              <li key={g.id}>
                <span
                  onClick={() =>
                    category &&
                    applyMegaFilter(
                      "category",
                      category,
                      "gender",
                      g
                    )
                  }
                >
                  {g.name}
                </span>
              </li>
            ))
          ) : (
            <li>
              <span className="muted">
                Coming soon
              </span>
            </li>
          )}
        </ul>
      </div>

      <div className="mega_col">
        <h6>By Shape</h6>

        <ul className="shape_list">
          {SHAPES.map((s) => {
            const match = allShape?.find(
              (x) =>
                x.name?.toLowerCase() ===
                s.label.toLowerCase()
            );

            return (
              <li
                key={s.key}
                className={!match ? "muted" : ""}
              >
                <span
                  onClick={() =>
                    match &&
                    category &&
                    applyMegaFilter(
                      "category",
                      category,
                      "frameShape",
                      match
                    )
                  }
                >
                  <ShapeIcon shapeKey={s.key} />

                  {s.label}
                </span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="mega_col">
        <h6>Top Brands</h6>

        <ul>
          {topBrands.length > 0 ? (
            topBrands.map((b) => (
              <li key={b.id}>
                <span
                  onClick={() =>
                    category &&
                    applyMegaFilter(
                      "category",
                      category,
                      "brands",
                      b
                    )
                  }
                >
                  {b.name}
                </span>
              </li>
            ))
          ) : (
            <li>
              <span className="muted">
                Coming soon
              </span>
            </li>
          )}
        </ul>

        <span
          className="mega_viewall"
          onClick={() =>
            navigate("/all-products")
          }
        >
          View All Brands →
        </span>
      </div>

      <div className="mega_col">
        <h6>Exclusive Brands</h6>

        <ul>
          {exclusiveBrands.length > 0 ? (
            exclusiveBrands.map((b) => (
              <li key={b.id}>
                <span
                  onClick={() =>
                    category &&
                    applyMegaFilter(
                      "category",
                      category,
                      "brands",
                      b
                    )
                  }
                >
                  {b.name}
                </span>
              </li>
            ))
          ) : (
            <li>
              <span className="muted">
                Coming soon
              </span>
            </li>
          )}
        </ul>

        <span
          className="mega_viewall"
          onClick={() =>
            navigate("/all-products")
          }
        >
          View All Exclusive →
        </span>
      </div>

      <div className="mega_col">
        <h6>
          {category?.name || "Categories"}
        </h6>

        <ul>
          {subcategories &&
          subcategories.length > 0 ? (
            subcategories.map((sc) => (
              <li key={sc.id}>
                <span
                  onClick={() =>
                    category &&
                    applyMegaFilter(
                      "category",
                      {
                        id: sc.id,
                        name: sc.name,
                      }
                    )
                  }
                >
                  {sc.name}
                </span>
              </li>
            ))
          ) : (
            <li>
              <span className="muted">
                Coming soon
              </span>
            </li>
          )}
        </ul>
      </div>

      <div className="mega_feature">
        {category?.image ? (
          <img
            src={
              process.env.REACT_APP_IMAGE_URL +
              category.image
            }
            alt={category.name}
          />
        ) : (
          <div className="mega_feature_placeholder" />
        )}

        <div className="mega_feature_caption">
          <p className="eyebrow">
            New Season
          </p>

          <p className="title">
            {category?.name || "Collection"}
          </p>

          <span
            className="mega_cta"
            onClick={() =>
              category &&
              applyFilter(
                "category",
                category
              )
            }
          >
            Explore Now →
          </span>
        </div>
      </div>
    </div>
  );

  const renderKidsMegaMenu = () => (
    <div className="mega_panel">

      {/* <div className="mega_col">
        <h6>Shop By</h6>

        <ul>
          <li>
            <span
              onClick={() =>
                kidsGender
                  ? applyFilter(
                      "gender",
                      kidsGender
                    )
                  : navigate("/all-products")
              }
            >
              All Kids
            </span>
          </li>

          {boysGender && (
            <li>
              <span
                onClick={() =>
                  applyFilter(
                    "gender",
                    boysGender
                  )
                }
              >
                Boys
              </span>
            </li>
          )}

          {girlsGender && (
            <li>
              <span
                onClick={() =>
                  applyFilter(
                    "gender",
                    girlsGender
                  )
                }
              >
                Girls
              </span>
            </li>
          )}

          {!boysGender &&
            !girlsGender && (
              <li>
                <span className="muted">
                  Coming soon
                </span>
              </li>
            )}
        </ul>
      </div> */}

      <div className="mega_col">
        <h6>By Shape</h6>

        <ul className="shape_list">
          {SHAPES.map((s) => {
            const match = allShape?.find(
              (x) =>
                x.name?.toLowerCase() ===
                s.label.toLowerCase()
            );

            return (
              <li
                key={s.key}
                className={!match ? "muted" : ""}
              >
                <span
                  onClick={() =>
                    match &&
                    applyMegaFilter(
                      "category",
                      kidsCat,
                      "frameShape",
                      match
                    )
                  }
                >
                  <ShapeIcon
                    shapeKey={s.key}
                  />

                  {s.label}
                </span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="mega_col">
        <h6>Top Brands</h6>

        <ul>
          {topBrands.length > 0 ? (
            topBrands.map((b) => (
              <li key={b.id}>
                <span
                  onClick={() =>
                    applyMegaFilter(
                      "category",
                      kidsCat,
                      "brands",
                      b
                    )
                  }
                >
                  {b.name}
                </span>
              </li>
            ))
          ) : (
            <li>
              <span className="muted">
                Coming soon
              </span>
            </li>
          )}
        </ul>

        <span
          className="mega_viewall"
          onClick={() =>
            navigate("/all-products")
          }
        >
          View All Brands →
        </span>
      </div>

      <div className="mega_col">
        <h6>Exclusive Brands</h6>

        <ul>
          {exclusiveBrands.length > 0 ? (
            exclusiveBrands.map((b) => (
              <li key={b.id}>
                <span
                  onClick={() =>
                    applyMegaFilter(
                      "category",
                      kidsCat,
                      "brands",
                      b
                    )
                  }
                >
                  {b.name}
                </span>
              </li>
            ))
          ) : (
            <li>
              <span className="muted">
                Coming soon
              </span>
            </li>
          )}
        </ul>

        <span
          className="mega_viewall"
          onClick={() =>
            navigate("/all-products")
          }
        >
          View All Exclusive →
        </span>
      </div>

      <div className="mega_col">
        <h6>Categories</h6>

        <ul>
          {eyeglassesCat && (
            <li>
              <span
                onClick={() =>
                  applyMegaFilter(
                    "gender",
                    kidsGender,
                    "category",
                    eyeglassesCat
                  )
                }
              >
                 Eyeglasses
              </span>
            </li>
          )}

          {sunglassesCat && (
            <li>
              <span
                onClick={() =>
                  applyMegaFilter(
                    "gender",
                    kidsGender,
                    "category",
                    sunglassesCat
                  )
                }
              >
                Kids Sunglasses
              </span>
            </li>
          )}

          {contactLensCat && (
            <li>
              <span
                onClick={() =>
                  applyMegaFilter(
                    "gender",
                    kidsGender,
                    "category",
                    contactLensCat
                  )
                }
              >
                Contact Lenses
              </span>
            </li>
          )}

          {!eyeglassesCat &&
            !sunglassesCat &&
            !contactLensCat && (
              <li>
                <span className="muted">
                  Coming soon
                </span>
              </li>
            )}
        </ul>
      </div>

      <div className="mega_feature">
        {kidsCat?.image ? (
          <img
            src={
              process.env.REACT_APP_IMAGE_URL +
              kidsCat.image
            }
            alt="Kids"
          />
        ) : (
          <div className="mega_feature_placeholder" />
        )}

        <div className="mega_feature_caption">
          <p className="eyebrow">
            New Season
          </p>

          <p className="title">
            Kids Collection
          </p>

          <span
            className="mega_cta"
            onClick={() =>
              kidsCat &&
              applyFilter(
                "category",
                kidsCat
              )
            }
          >
            Explore Now →
          </span>
        </div>
      </div>
    </div>
  );

  const NAV_ITEMS = [
    {
      key: "new-arrivals",
      label: "New Arrivals",
      to: "/all-products",
    },

    {
      key: "meta",
      label: "Meta AI",
      badge: "NEW",
      onClick: () =>
        applySingleCategory(metaCategory),
    },

    {
      key: "sunglasses",
      label: "Sunglasses",
      mega: () =>
        renderCategoryMegaMenu(
          sunglassesCat
        ),
    },

    {
      key: "eyeglasses",
      label: "Spectacle Frames",
      mega: () =>
        renderCategoryMegaMenu(
          eyeglassesCat
        ),
    },

    {
      key: "kids",
      label: "Kids",
      mega: renderKidsMegaMenu,
    },

    {
  key: "contact-lenses",
  label: "Contact Lenses",
  onClick: () =>
    contactLensCat
      ? applySingleCategory(contactLensCat)
      : navigate("/all-products"),
},

    {
      key: "Bapat Benefits",
      label: "Bapat Benefits",
      to: "/bapat-benefits",
      danger: true,
    },

    {
      key: "brands",
      label: "Brands",

      mega: () => (
        <div className="mega_panel mega_panel_wide">
          {[0, 1, 2, 3].map((col) => (
            <div
              className="mega_col"
              key={col}
            >
              <ul>
                {sortedBrands
                  .filter(
                    (_, i) =>
                      i % 4 === col
                  )
                  .map((b) => (
                    <li key={b.id}>
                      <span
                        onClick={() =>
                          applyFilter(
                            "brands",
                            b
                          )
                        }
                      >
                        {b.name}
                      </span>
                    </li>
                  ))}

                {sortedBrands.length === 0 && (
                  <li>
                    <span className="muted">
                      Coming soon
                    </span>
                  </li>
                )}
              </ul>
            </div>
          ))}
        </div>
      ),
    },

    {
      key: "about-us",
      label: "About Us",

      mega: () => (
        <div className="mega_panel mega_panel_simple">
          <div className="mega_col">
            <ul>
              <li>
                <Link
                  to="/customer-reviews"
                  onClick={() =>
                    setActiveMenu(null)
                  }
                >
                  Customer Reviews
                </Link>
              </li>

              <li>
                <span
                  onClick={() => {
                    setModalShow(true);
                    setActiveMenu(null);
                  }}
                >
                  Appointments
                </span>
              </li>

              <li>
                <Link
                  to="/our-boutiques"
                  onClick={() =>
                    setActiveMenu(null)
                  }
                >
                  Our Boutiques
                </Link>
              </li>

              <li>
                <Link
                  to="/about-us"
                  onClick={() =>
                    setActiveMenu(null)
                  }
                >
                  Our Legacy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      ),
    },

    {
      key: "quick-quiz",
      label: "Quick Quiz",
      to: "/quick-quiz",
    },
  ];

  const renderNavLink = (item) => {
    const isActive =
      item.to &&
      location.pathname ===
        item.to.split("?")[0];

    if (item.mega) {
      return (
        <span
          className={`nav_link ${
            activeMenu === item.key
              ? "active"
              : ""
          } ${
            item.danger ? "danger" : ""
          }`}
          onClick={() =>
            setActiveMenu(
              activeMenu === item.key
                ? null
                : item.key
            )
          }
        >
          {item.label}

          {item.badge && (
            <span className="nav_badge">
              {item.badge}
            </span>
          )}
        </span>
      );
    }

    if (item.onClick) {
      return (
        <span
          className={`nav_link ${
            item.danger ? "danger" : ""
          }`}
          onClick={item.onClick}
        >
          {item.label}

          {item.badge && (
            <span className="nav_badge">
              {item.badge}
            </span>
          )}
        </span>
      );
    }

    return (
      <Link
        to={item.to}
        className={`nav_link ${
          isActive ? "active" : ""
        } ${
          item.danger ? "danger" : ""
        }`}
        onClick={() => {
          setMobileOpen(false);
          setActiveMenu(null);
        }}
      >
        {item.label}

        {item.badge && (
          <span className="nav_badge">
            {item.badge}
          </span>
        )}
      </Link>
    );
  };

  return (
    <section className="header_main">

      <div className="header_blue_shell">

        <div className="header_top">

          <button
            className="mobile_toggle d-lg-none"
            aria-label="Open menu"
            onClick={() =>
              setMobileOpen(true)
            }
          >
            <span />
            <span />
            <span />
          </button>

          {/* CENTER LOGO */}
          <Link
            to="/"
            className="brand_logo_link"
            onClick={() =>
              setMobileOpen(false)
            }
          >
            <img
              className="head_logo"
              src={
                process.env.PUBLIC_URL +
                "/assets/images/logo/logo.png"
              }
              alt="logo"
            />
          </Link>

          <div className="profilesec">

            <Link
              to="/wishlist"
              className="proflink"
            >
              <FaHeart className="proficn_svg" />

              <span className="profile_label">
                Wishlist
              </span>
            </Link>

            <Link
              to={
                is_signin
                  ? "/my-account"
                  : "/login"
              }
              className="proflink"
            >
              <FaUser className="proficn_svg" />

              <span className="profile_label">
                {is_signin
                  ? user?.name || "Account"
                  : "Sign In"}
              </span>
            </Link>

            <Link
              to="/cart"
              className="proflink cart_link"
            >
              <FaShoppingCart className="proficn_svg" />

              <span className="profile_label">
                Cart
              </span>

              <span className="cart_badge">
                {cartItems?.length || 0}
              </span>
            </Link>

          </div>
        </div>

        <nav className="header_nav d-none d-lg-block">

          <ul className="nav_list">

            {NAV_ITEMS.map((item) => (
              <li
                key={item.key}
                className="nav_item"
                onMouseEnter={() =>
                  item.mega &&
                  openMenu(item.key)
                }
                onMouseLeave={() =>
                  item.mega &&
                  scheduleClose()
                }
              >

                {renderNavLink(item)}

                {item.mega && (
                  <div
                    className={`mega_dropdown ${
                      activeMenu === item.key
                        ? "open"
                        : ""
                    }`}
                    onMouseEnter={() => {
                      if (closeTimer.current) {
                        clearTimeout(
                          closeTimer.current
                        );
                      }
                    }}
                    onMouseLeave={() =>
                      scheduleClose()
                    }
                  >
                    {activeMenu === item.key &&
                      item.mega()}
                  </div>
                )}

              </li>
            ))}

          </ul>

        </nav>
      </div>

      <div
        className={`mobile_drawer ${
          mobileOpen ? "open" : ""
        }`}
      >

        <div className="mobile_drawer_header">

          <span className="mobile_drawer_title">
            Menu
          </span>

          <span
            onClick={() =>
              setMobileOpen(false)
            }
            className="mobile_close"
          >
            &times;
          </span>

        </div>

        <ul className="mobile_nav_list">

          {NAV_ITEMS.map((item) => (
            <li key={item.key}>

              <div
                className="mobile_nav_row"
                onClick={() => {

                  if (item.mega) {
                    setMobileAccordion(
                      mobileAccordion ===
                        item.key
                        ? null
                        : item.key
                    );
                  } else if (
                    item.onClick
                  ) {
                    item.onClick();
                    setMobileOpen(false);
                  } else {
                    navigate(item.to);
                    setMobileOpen(false);
                  }

                }}
              >

                <span
                  className={
                    item.danger
                      ? "danger"
                      : ""
                  }
                >
                  {item.label}

                  {item.badge && (
                    <span className="nav_badge">
                      {item.badge}
                    </span>
                  )}
                </span>

                {item.mega && (
                  <span className="mobile_plus">
                    {mobileAccordion ===
                    item.key
                      ? "−"
                      : "›"}
                  </span>
                )}

              </div>

              {item.mega &&
                mobileAccordion ===
                  item.key && (
                  <div className="mobile_submenu">
                    {item.mega()}
                  </div>
                )}

            </li>
          ))}

        </ul>

        <div className="mobile_drawer_footer">
          <span>Need Help?</span>

          <a href="tel:+9318001230000">
            Call: 1800-123-0000
          </a>
        </div>

      </div>

      {mobileOpen && (
        <div
          className="mobile_backdrop"
          onClick={() =>
            setMobileOpen(false)
          }
        />
      )}

      <Book_appointment_modal
        show={modalShow}
        onHide={() =>
          setModalShow(false)
        }
      />

    </section>
  );
}

export default Header;